import styled from 'styled-components';

import { pickColor } from 'themes/helpers/pickColor';

import { Headline } from 'components/Headline';

const Title = styled(Headline)`
  margin-bottom: 5rem;
  text-transform: uppercase;

  &::after {
    content: '';

    display: block;

    width: 4rem;
    margin: 0 auto 3rem;
    padding-top: 2rem;

    border-bottom: 0.2rem solid ${pickColor('grayDark')};
  }
`;

const Wrapper = styled.div`
  margin: 2rem 0;
`;

export { Title, Wrapper };
